import React from 'react';
import ReactTable from 'react-table';
import _ from 'lodash';

import ReactComponentHelper from '../../helper/ReactComponentHelper';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import Logger, { LOG_LEVELS } from '../../../utils/logger';
import Pagination from '../../page/Pagination'
import { withFullStoryExclude } from '../../../utils/fullStoryHelper';

const FORM_NAME = 'MANUAL_DOCUMENTS_VAT_BOX_LIST_FORM';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);

class ManualDocumentsVATBoxList extends React.Component {

    constructor(props) {
        super(props);
        this.getCols = this.getCols.bind(this);
    }

    onRowDeleteHandler(row) {
        return () => {
            this.props.onRowDelete(row);
        };
    }

    getCols() {
        let cols = [
            {
                Header: (<LanguageStringResolver string='manualDocumentsVATBoxList_BoxName'></LanguageStringResolver>),
                accessor: 'boxName',
                filterable: true,
                sortable: true
            },
            {
                Header: (<LanguageStringResolver string='manualDocumentsVATBoxList_BoxValue' />),
                accessor: 'boxValue',
                filterable: true,
                headerClassName: withFullStoryExclude(),
                ...ReactComponentHelper.getCurrencyColumnOptions({
                    isSensitive: true
                })
            },
            {
                Header: (<LanguageStringResolver string='manualDocumentsVATBoxList_BoxType' />),
                accessor: 'boxType',
                filterable: true,
                sortable: true
            },
            {
                Header: (<LanguageStringResolver string='manualDocumentsVATBoxList_ReturnType' />),
                accessor: 'returnType',
                filterable: true,
                sortable: true
            },
            {
                Header: (<LanguageStringResolver string='manualDocumentsVATBoxList_Action' />),
                accessor: 'action',
                filterable: false,
                sortable: false,
                Cell: (row) => (    
                    <a className="tertiary" href="#" onClick={this.onRowDeleteHandler(row)}><LanguageStringResolver string='manualDocumentsVATBoxList_Remove' /></a>
                ), 
            }
        ];
        return cols;
    }

    render () {
        log.debug('render() : ', this.props);
        const data = this.props.data;
        const columns = this.getCols();
        const tableOptions = this.props.tableOptions;
        return (
            <div>
                <ReactTable
                    data={data}
                    columns={columns}
                    minRows={5}
                    defaultPageSize={5}
                    {...tableOptions}
                    PaginationComponent={Pagination}
                />
            </div>
        );
    }
}

export default ManualDocumentsVATBoxList;